import React from "react";
import PropTypes from "prop-types";
import { Button as BootstrapButton, Spinner } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit } from "@fortawesome/free-solid-svg-icons";
import editIcon from "../../assets/icons/edit-btn-icon.svg";

/**
 * Primary UI component for user interaction
 */
export const Button = ({
  primary,
  backgroundColor,
  size,
  label,
  edit,
  variant,
  type,
  ...props
}) => {
  return (
    <BootstrapButton
      type={type}
      variant={variant}
      className={`rounded-pill ${props.className}`}
      style={backgroundColor && { backgroundColor }}
      {...props}
    >
      {edit && <img src={editIcon} className="mx-1 pe-1" alt="edit" />}
      {label === 'Downloading...' ? <>Downloading... <Spinner className="custom-spinner" /></> : label}
    </BootstrapButton>
  );
};

Button.propTypes = {
  primary: PropTypes.bool,
  backgroundColor: PropTypes.string,
  size: PropTypes.oneOf(["small", "medium", "large"]),
  label: PropTypes.string.isRequired,
  edit: PropTypes.bool,
  variant: PropTypes.string,
  onClick: PropTypes.func,
  type: PropTypes.string,
  className: PropTypes.string
};

Button.defaultProps = {
  backgroundColor: null,
  primary: false,
  size: "medium",
  onClick: undefined
};
